import { Component, Injectable, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbCalendar, NgbDateParserFormatter, NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import swal from 'sweetalert2';
import { RestService } from '../../master-services/Rest/rest.service';
import { ResumenesService } from '../../master-services/resumenes/resumenes.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { ModalBasicComponent } from '../../shared/modal-basic/modal-basic.component';
import { id } from '@swimlane/ngx-datatable/release/utils';
import { UserService } from '../../master-services/User/user.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PersonalService } from '../../master-services/personal/personal.service';
// import * as Excel from 'exceljs';
// import * as ExcelProper from "exceljs";



const I18N_VALUES = {
  'fr': {
    weekdays: ['Lun', 'Mar', 'Mié', 'Juv', 'Vie', 'Sáb', 'Dom'],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Agos', 'Sep', 'Oct', 'Nov', 'Dic'],
  }
  // other languages you would support
};
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';


interface TableInterface {
  Actividad?: string;
  Cliente?: string;
  Control?: string;
  Tecnico?:string;
  Sucursal_tecnico?:string;
  Fecha_Inicio?: string;
  Fecha_Final?: string;
  Duracion?: string;
  Aprobacion?: string;
  Observaciones?: string;
}

interface TableNoSeguimInterface {
  nombre?: string;
  correo?: string;
}



export class I18n {
  language = 'fr';
}

@Component({
  selector: 'app-master-personal-monitoring',
  templateUrl: './master-personal-monitoring.component.html',
  styleUrls: ['./master-personal-monitoring.component.scss',
  '../../../assets/icon/icofont/css/icofont.scss'],
  providers: [I18n, {provide: NgbDatepickerI18n, useClass: MasterPersonalMonitoringComponent}]
})
export class MasterPersonalMonitoringComponent extends NgbDatepickerI18n {

  dataExcel: Array<TableInterface> = [];
  tableExcel: TableInterface;
  user: any = { id: null, boss: null };

  selectedRegionalId:any = 0;
  selectedRegionalName: any;
  selectedTechnicianId: any = 0;
  selectedBusinessId: any = 0;
  selectedBranchOfficeId: any = 0;
  customers: any;
  now:any;
  regionals:any;
  activities: any;

  noSeguim: any;

  updatingActivityId = null;
  selectedStartDate = '';
  selectedFinishDate = '';

  selectedActivity: any;
  updatingObservation = false;
  updatedObservation = '';

  branchOffices: any;

  technician: any;
  rowsClient: any;

  forklift: any = '';
  customerName: any = '';
  branch: any = '';

  fromDate: NgbDateStruct;
  untilDate: NgbDateStruct;

  userId: number;

  activityForm: FormGroup;

  @ViewChild('modalUpdateActivity') modalUpdateActivity: ModalBasicComponent;
  @ViewChild('modaleActivityObservations') modaleActivityObservations: ModalBasicComponent;

  constructor(private restService: RestService,private calendar: NgbCalendar, public formatter: NgbDateParserFormatter, 
    private _i18n: I18n, private router: Router, private resumenesService: ResumenesService, private fb: FormBuilder,
    private userService: UserService, private personalService: PersonalService,
  ) { 
    super();

    var date = new Date();
    var ngbDateStruct = { day: date.getDate(), month: date.getMonth()+1, year: date.getFullYear()};
    this.userId = Number(localStorage.getItem("userid"));
               
    this.fromDate=ngbDateStruct;
    this.untilDate=ngbDateStruct;

    console.log(   this.fromDate);
    console.log(   this.untilDate);

    this.getUserData();
    this.getActivities();
    this.getCustomers();
    this.generateActivityForm();
    this.getRegional();
    this.getFilters();
  }

  ngOnInit() {
    
  }

  generateActivityForm() {
    this.activityForm = this.fb.group({
      personal_activities_id: [null, [
        Validators.required
      ]],
      customer_id: [null],
      service_control: [null],
      user_id: [null, [
        Validators.required
      ]],
      start: ['', [
        Validators.required
      ]],
      finish: ['', [
        Validators.required
      ]],
    });
  }

  assignCurrentlyActivityValues(activity: any) {
    this.activityForm.patchValue({
      personal_activities_id: activity.personal_activities_id,
      customer_id: activity.customer_id,
      service_control: activity.service_control,
      user_id: activity.user_id,
      start: this.formatDateForInput(activity.start),
      finish: this.formatDateForInput(activity.finish),
    });
    console.log(activity);
    console.log(this.activityForm.value);
    console.log(this.activities);
  }

  getRegional(){
    this.restService.getRegionalAll().then(data => {
      const resp: any = data;
      console.log(data);
      swal.close();
      this.regionals  = resp.data;
    }).catch(error => {
      console.log(error);
    });
  }
  
  getCustomers(){
    this.restService.getCustomer().then(data => {
      const resp: any = data;
      swal.close();
      this.customers = resp.data;
    }).catch(error => {
      console.log(error);
    });
  }
  
  getUsersByRegional(){
    swal({
      title: 'Obteniendo información ...',
      allowOutsideClick: false
    });
    swal.showLoading();
    
    const selectedRegional = this.regionals.find(regional => regional.id === this.selectedRegionalId);
    this.selectedRegionalName = selectedRegional ? selectedRegional.description : '';

    this.restService.getUserRegional(this.selectedRegionalId, null).then(data => {
      const resp: any = data;

      this.technician = resp.data
      swal.close();
    }).catch(error => {
      swal.close();
      swal({
        title:'Error',
        text: 'Ha ocurrido un error',
        type: 'error'
       });
      console.log(error);
    });
  }

  public exportAsExcelFile(rows: any[], noSeguimRows: any[],  excelFileName: string): void {
    console.log('/*/*/*/*/*/*/*/*/*/**', noSeguimRows);
    if (rows.length > 0 || noSeguimRows.length > 0) {
      const worksheet1: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rows);
      const worksheet2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(noSeguimRows);
      const workbook: XLSX.WorkBook = {
        Sheets: {
          'Seguim': worksheet1,
          'No_Seguim': worksheet2,
        }, SheetNames: ['Seguim', 'No_Seguim']
      };

      const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
      this.saveAsExcelFile(excelBuffer, excelFileName);
    }else{
      swal({
        title:'Error',
        text: 'Ha ocurrido un error',
        type: 'error'
      });
    }
  }
  private saveAsExcelFile(buffer: any, baseFileName: string): void {
    const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
    FileSaver.saveAs(data, baseFileName +EXCEL_EXTENSION);
    swal.close();
    this.dataExcel.length=0;
  }

  // private getDateFormat(date: Date): string {
  //   return formatDate(date, 'yyyyMMdd_HHmmss', 'en-US');
  // }
  
  getFilters() {  
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();
    let params='';
    let cont=0;

    var day = (this.fromDate.day < 10 ? '0' : '') +this.fromDate.day;
    // 01, 02, 03, ... 10, 11, 12
    let month = ((this.fromDate.month) < 10 ? '0' : '') + (this.fromDate.month);
    // 1970, 1971, ... 2015, 2016, ...
    var year = this.fromDate.year;

    // until poner los ceros
    var dayUntil = (this.untilDate.day < 10 ? '0' : '') +this.untilDate.day;
    // 01, 02, 03, ... 10, 11, 12
    let monthUntil = ((this.untilDate.month) < 10 ? '0' : '') + (this.untilDate.month);
    // 1970, 1971, ... 2015, 2016, ...
    var yearUntil = this.untilDate.year;    

    var fromD = year +'-'+ month+'-'+ day;
    var untilD = yearUntil +'-'+ monthUntil+'-'+ dayUntil;

    //  var fromD = this.fromDate.year+'-'+this.fromDate.month+'-'+this.fromDate.day; //31 de diciembre de 2015
    //  var untilD = this.untilDate.year+'-'+this.untilDate.month+'-'+this.untilDate.day;
    var from_date= fromD+' 00:00:00';
    var to_date=untilD+' 23:59:59';

    params='from_date='+from_date+'&to_date='+to_date;
  
    
    if(this.selectedTechnicianId!=0){
      params=params+'&&user_id='+this.selectedTechnicianId;
    } else if (this.selectedRegionalId !== 0) {
      params=params+'&&regional_id='+this.selectedRegionalId;
    }

    this.resumenesService.getPersonalMonitoring(params).then(data => {
      const resp: any = data;
      // let date = new Date(this.rowsClient.finish - this.rowsClient.start);
      
      if(resp.error){
        swal({
          title:'Oops',
          text: 'Hubo un error en la consulta.',
          type: 'error'
        });
        return;
      }

      this.rowsClient = resp.data;

      this.resumenesService.getNoPersonalMonitoring(params)
        .subscribe({
          next: (res: any) => {
            this.noSeguim = res.data;
            console.log('Técnicos sin seguimiento:', this.noSeguim);
            swal.close();
          },
          error: err => {
            console.error('Error en getNoPersonalMonitoring:', err);
            swal({
              title: 'Error',
              text: 'No se pudo obtener los técnicos sin seguimiento.',
              type: 'error'
            });
          }
        });
    }).catch(error => {
      console.log(error);
    });  
  }

  saveExcel(table: any, noSeguimTable: any){
    console.log(table);
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();
    console.log('++++++++++++++++', table[0]);
    console.log('++++++++++++++++', noSeguimTable[0]);
    for(let value of table){
      this.tableExcel = {
        Actividad: value.personal_activitie && value.personal_activitie.description ? value.personal_activitie.description : '',
        Cliente: value.customer_text ? value.customer_text : '',
        Control: value.service_control ? value.service_control : '',
        Tecnico: value.users && value.users.name ? value.users.name : '',
        Sucursal_tecnico: this.selectedRegionalName && this.selectedRegionalName.trim() !== '' 
          ? this.selectedRegionalName 
          : (value.users && value.users.first_regional 
              ? value.users.first_regional.regional_name 
              : ''),
        Fecha_Inicio: value.start ? value.start : '',
        Fecha_Final: value.finish ? value.finish : '',
        Duracion: value.duration_activity ? value.duration_activity : '',
        Aprobacion: value.user_approve && value.user_approve.name ? value.user_approve.name : '',
        Observaciones: value.boss_observations ? value.boss_observations : '',
      };
      this.dataExcel.push(this.tableExcel);
      console.log(this.dataExcel);
    }
    
    const NSTable: TableNoSeguimInterface[] = [];
    for(let value of noSeguimTable){
      const NSData = {
        nombre: value.name ? value.name : '',
        correo: value.email ? value.email : '',
        sucursal: this.selectedRegionalName && this.selectedRegionalName.trim() !== ''
          ? this.selectedRegionalName
          : (value.regional_name ? value.regional_name : ''),
      };
      NSTable.push(NSData);
    }
    this.exportAsExcelFile(this.dataExcel, NSTable, 'Monitoreo Personal');
  }

  approveActivity(id: number) {
    swal({
      title: 'actualizando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    const approvedBy = { approved_by: this.userId };

    this.resumenesService.approvePersonalMonitoring(id, approvedBy)
      .subscribe({
        next: res => {
          this.getFilters();
          swal.close();
        },
        error: e => {
          swal.close();
          swal({
            title: 'Error al aprobar',
            text: 'No se pudo completar el proceso. Intente nuevamente.',
            type: 'error',
          });
        }
      });
  }
  
  createActivity() {
    swal({
      title: 'guardando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    const selectedCustomer = this.customers.find(customer => customer.id === this.activityForm.value.customer_id);
    const selectedActivity = this.activities.find(activity => activity.id === this.activityForm.value.personal_activities_id);

    const newData = {
      ...this.activityForm.value,
      start: this.activityForm.value.start.replace('T', ' '),
      finish: this.activityForm.value.finish.replace('T', ' '),
      customer_text: selectedCustomer ? selectedCustomer.business_name : '',
      description: selectedActivity ? selectedActivity.description : '',
    };

    this.resumenesService.createPersonalMonitoring(newData)
      .subscribe({
        next: res => {
          console.log('**********************************', res);
          this.getFilters();
          this.toggleActivityForm();
          swal.close();
        },
        error: e => {
          swal.close();
          swal({
            title: 'Error al aprobar',
            text: 'No se pudo completar el proceso. Intente nuevamente.',
            type: 'error',
          });
        }
      });
  }
  
  updateActivity() {
    swal({
      title: 'actualizando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    const newData = {
      ...this.activityForm.value,
      start: this.formatDateWithSeconds(this.activityForm.value.start),
      finish: this.formatDateWithSeconds(this.activityForm.value.finish)
    };

    this.resumenesService.updatePersonalMonitoring(this.updatingActivityId, newData)
      .subscribe({
        next: res => {
          console.log('**********************************', res);
          console.log('**********************************', this.activityForm.value.start.replace('T', ' '));
          console.log('**********************************', this.activityForm.value.finish.replace('T', ' '));
          this.getFilters();
          this.toggleActivityForm();
          swal.close();
        },
        error: e => {
          swal.close();
          swal({
            title: 'Error al aprobar',
            text: 'No se pudo completar el proceso. Intente nuevamente.',
            type: 'error',
          });
        }
      });
  }
  
  updateActivityObservation() {
    swal({
      title: 'actualizando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    this.resumenesService.updatePersonalMonitoringObservation(this.selectedActivity.id, this.updatedObservation)
      .subscribe({
        next: res => {
          console.log('**********************************', res);
          this.getFilters();
          this.toggleObservationsModal();
          swal.close();
        },
        error: e => {
          swal.close();
          swal({
            title: 'Error al modificar',
            text: 'No se pudo completar el proceso. Intente nuevamente.',
            type: 'error',
          });
        }
      });
  }

  // generate(){
  //   const title = 'Car Sell Report';
  //   const header = ["Year", "Month", "Make", "Model", "Quantity", "Pct"]
  //   const data = [
  //     [2007, 1, "Volkswagen ", "Volkswagen Passat", 1267, 10],
  //     [2007, 1, "Toyota ", "Toyota Rav4", 819, 6.5],
  //     [2007, 1, "Toyota ", "Toyota Avensis", 787, 6.2],
  //     [2007, 1, "Volkswagen ", "Volkswagen Golf", 720, 5.7],
  //     [2007, 1, "Toyota ", "Toyota Corolla", 691, 5.4],
  //   ];

  //   // let workbook = new Excel.Workbook();
  //   let workbook = new Excel.Workbook();
  //   let worksheet = workbook.addWorksheet('Car Data');

  //       // Add new row
  //   let titleRow = worksheet.addRow([title]);

  //   // Set font, size and style in title row.
  //   titleRow.font = { name: 'Comic Sans MS', family: 4, size: 16, underline: 'double', bold: true };

  //   // Blank Row
  //   worksheet.addRow([]);

  //   //Add row with current date
  //   let subTitleRow = worksheet.addRow(['Date : ' + new Date()]);

  //   //Add Header Row
  //   let headerRow = worksheet.addRow(header);

  //   // Cell Style : Fill and Border
  //   headerRow.eachCell((cell, number) => {
  //     cell.fill = {
  //       type: 'pattern',
  //       pattern: 'solid',
  //       fgColor: { argb: 'FFFFFF00' },
  //       bgColor: { argb: 'FF0000FF' }
  //     }
  //     cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
  //   });

  //   // Add Data and Conditional Formatting
  //   data.forEach(d => {
  //     let row = worksheet.addRow(d);
  //     let qty = row.getCell(5);
  //     let color = 'FF99FF99';
  //     if (+qty.value < 500) {
  //       color = 'FF9999'
  //     }
  //     qty.fill = {
  //       type: 'pattern',
  //       pattern: 'solid',
  //       fgColor: { argb: color }
  //     }
  //   }
  //   );

  //   workbook.xlsx.writeBuffer().then((data) => {
  //     let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //     FileSaver.saveAs(blob, 'CarData.xlsx');
  //   });
  // }

  
  onDateSelectionFrom(date: any) {

    if(this.untilDate){
    var fromD = new Date(this.fromDate.year, this.fromDate.month, this.fromDate.day); //31 de diciembre de 2015
    var untilD = new Date(this.untilDate.year, this.untilDate.month, this.untilDate.day);
 
    console.log(this.fromDate.day);
    if(fromD> untilD){
      console.log('es mayor');
      this.untilDate=this.fromDate;
    }
  }
  }

  onDateSelectionUntil(date: any) {
    var fromD = new Date(this.fromDate.year, this.fromDate.month, this.fromDate.day); //31 de diciembre de 2015
    var untilD = new Date(this.untilDate.year, this.untilDate.month, this.untilDate.day);
    if( untilD< fromD){
      console.log('es mayor');
      this.fromDate=this.untilDate;
    }
}

  onDateSelection(date: any) {
    const start = new Date(this.selectedStartDate);
    const finish = new Date(this.selectedFinishDate);

    if (finish < start ) {
      this.selectedStartDate = this.selectedFinishDate;
    }
  }

  toggleActivityForm(activity: any = null){
    if (this.modalUpdateActivity.visible) {
      this.modalUpdateActivity.hide();
      this.activityForm.reset();
      this.updatingActivityId = null;
      return;
    }

    if (activity !== null) {
      this.updatingActivityId = activity.id;
      this.assignCurrentlyActivityValues(activity);
    }

    this.modalUpdateActivity.show();
  }
  
  toggleObservationsModal(activity: any = null){
    if (this.modaleActivityObservations.visible) {
      this.modaleActivityObservations.hide();
      this.updatingObservation = false;
      this.updatedObservation = '';
      return;
    }

    this.selectedActivity = activity;
    this.modaleActivityObservations.show();
  }
  
  toggleUpdateObservations(observation: string = ''){
    if (this.updatingObservation) {
      this.updatingObservation = false;
      this.updatedObservation = '';
      return;
    }

    this.updatingObservation = true;
    this.updatedObservation = observation;
  }

getWeekdayShortName(weekday: number): string {
  return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
}
getMonthShortName(month: number): string {
  return I18N_VALUES[this._i18n.language].months[month - 1];
}
getMonthFullName(month: number): string {
  return this.getMonthShortName(month);
}

  formatDateForInput(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const seconds = ('0' + date.getSeconds()).slice(-2);
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  formatDateWithSeconds(dateString: string): string {
    const date = new Date(dateString);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
  }


  getUserData() {
    console.log('/*/*/*/*/*/*/*/*/*/*/*/*/*/*/*/*', Number(localStorage.getItem("userid")));
    this.userService.getUser(Number(localStorage.getItem("userid")))
      .then(data => {
        const resp: any = data;
        if (resp.error) {
          swal({
            title: "Error",
            text: "Ha ocurrido un error",
            type: "error",
          });
        } else {
          this.user = resp.data;
          console.log('/*/*/*/*/*/*/*/*/*/*/*/*/*/*/*/*', this.user);
        }
      });
  }
  
  getActivities() {
    this.personalService.getActiviti()
      .then(data => {
        const resp: any = data;
        if (resp.error) {
          swal({
            title: "Error",
            text: "Ha ocurrido un error",
            type: "error",
          });
        } else {
          this.activities = resp.data;
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/master/master-personal-monitoring/master-personal-monitoring.component.ts